import { CommonTabbarContext } from "@/App";
import { TAB_TYPE } from "@/enums/tab-type";
import DrawTabPage from "@/routes/tab-routes/draw";
import { useContext, useEffect } from "react";
import { Navigate, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { CommonTabbarState, TabRoute } from "@/global/components/common-tabbar";
import DeviceTabMainPage from "./device";
import MonitorParameterDetail from "./monitor-parameter";
import MonitorObjectDetail from "./monitor-object";
import WarningRecordPanel from "./warning";
import TestRecordPanel from "./test-record";
import MonitorRelationPanel from "./monitor-relation";
import MonitorThresholdPanel from "./monitor-threshold";
import CalibrationCameraPanel from "./calibration";

export const DRAW_MAIN_KEY = "draw-main"
export default function TabRoutes() {
    const { projectId } = useParams();
    const commonTabbarContext = useContext<CommonTabbarState>(CommonTabbarContext);
    const navigate = useNavigate();

    useEffect(() => {
        // 注册闭包路由方法
        commonTabbarContext.registerNavigate(navigateTo);
        // 添加默认的tab
        let mainDrawTab: TabRoute = {
            title: "绘图区",
            url: `${TAB_TYPE.DRAW}/${DRAW_MAIN_KEY}`
        }
        commonTabbarContext.pushRoute(mainDrawTab)
    }, [projectId])

    const navigateTo = (url: string) => {
        setTimeout(() => {
            navigate(url)
        }, 0)
    };

    return (
        <Routes>
            <Route path={`${TAB_TYPE.DRAW}/:drawKey`} element={<DrawTabPage />} />
            <Route path={`${TAB_TYPE.DEVICE}/*`} element={<DeviceTabMainPage />} />
            <Route path={`${TAB_TYPE.ROOF_SLAB}/:roofSlabUuid`} element={<DrawTabPage tabTitle="绘制屋面板截面" tabClosable={true} />} />
            <Route path={`${TAB_TYPE.GUTTER}/:gutterUuid`} element={<DrawTabPage tabTitle="绘制天沟截面" tabClosable={true} />} />
            <Route path={`${TAB_TYPE.MONITOR_RELATION}`} element={<MonitorRelationPanel />} />
            <Route path={`${TAB_TYPE.MONITOR_THRESHOLD}`} element={<MonitorThresholdPanel />} />
            <Route path={`${TAB_TYPE.MONITOR_PARAMETER}/:monitorParameterId`} element={<MonitorParameterDetail />} />
            <Route path={`${TAB_TYPE.MONITOR_OBJECT}/:monitorObjectId`} element={<MonitorObjectDetail />} />
            <Route path={`${TAB_TYPE.WARNING}`} element={<WarningRecordPanel />} />
            <Route path={`${TAB_TYPE.TEST_RECORD}/:testDate`} element={<TestRecordPanel />} />
            <Route path={`${TAB_TYPE.CALIBRATION}`} element={<CalibrationCameraPanel />} />
            <Route path="*" element={<Navigate to={`${TAB_TYPE.DRAW}/${DRAW_MAIN_KEY}`} />} />
        </Routes>
    )
}